import ComparisonCards from "components/ComparisonCards";
import type { ReactStoryblokComponent } from "types/storyblok";
import type { ComparisonCardsAdapterProps } from "./ComparisonCards.d";

const ComparisonCardsAdapter = ({ blok: { content = [] } }: ReactStoryblokComponent<ComparisonCardsAdapterProps>) => (
  <ComparisonCards content={content} />
);
export default ComparisonCardsAdapter;
